import { createContext, useContext } from 'react';

export type AccordionKey =
  | 'kid-accordion'
  | 'costs-and-charges-accordion'
  | 'product-governance-accordion'
  | 'theoretical-value-accordion';

export const AccordionContext = createContext<{ selected: AccordionKey[] }>({ selected: [] });

export function useIsAccordionOpened(key: AccordionKey) {
  const { selected } = useContext(AccordionContext);
  return selected.includes(key);
}
